import axios from 'axios';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Create axios instance
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Request Interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      toast.error("Your session expired. Please login again", {
        position: "bottom-right",
      });

      localStorage.removeItem('token');
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export const createGetRequest = async (url, params = {}) => {
  return apiClient.get(url, { params });
};
// ✅ API Methods

export const getRequest = async (url, params = {}) => {
  try {
    const response = await apiClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error(`GET request failed for ${url}`, error);
    throw error;
  }
};

export const postRequest = async (url, data) => {
  try {
    const isFormData = data instanceof FormData;

    const response = await apiClient.post(url, data, {
      headers: {
        'Content-Type': isFormData
          ? 'multipart/form-data'
          : 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error(`POST request failed for ${url}`, error);
    throw error;
  }
};

export const patchRequest = async (url, data) => {
  try {
    const isFormData = data instanceof FormData;

    const response = await apiClient.patch(url, data, {
      headers: {
        'Content-Type': isFormData
          ? 'multipart/form-data'
          : 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error(`PATCH request failed for ${url}`, error);
    throw error;
  }
};

export const deleteRequest = async (url) => {
  try {
    const response = await apiClient.delete(url);
    return response.data;
  } catch (error) {
    console.error(`DELETE request failed for ${url}`, error);
    throw error;
  }
};

export const putRequest = async (url, data = {}, config = {}) => {
  try {
    const isFormData = data instanceof FormData;

    const response = await apiClient.put(url, data, {
      headers: {
        'Content-Type': isFormData
          ? 'multipart/form-data'
          : 'application/json',
      },
      ...config,
    });

    return response.data;
  } catch (error) {
    console.error(`PUT request failed for ${url}`, error);
    throw error;
  }
};
// Optional parallel calls
export const parallelCall = async (requests) => {
  return axios.all(requests);
};